import { createTheme, ThemeOptions } from '@mui/material/styles';
import { colors } from './palette';

const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: colors.primaryDark,
      light: colors.primaryLight,
      dark: colors.primaryDark,
    },
    secondary: {
      main: colors.accent,
      light: colors.secondaryLight,
      dark: colors.secondaryDark,
    },
    background: {
      default: colors.primaryLight,
      paper: colors.primaryDark,
    },
    text: {
      primary: colors.primaryDark,
      secondary: colors.primaryLight,
    },
  },
  typography: {
    fontFamily: `'Cinzel', serif`,
    h1: { fontSize: '2.5rem', fontWeight: 700 },
    h2: { fontSize: '2rem', fontWeight: 700 },
    h3: { fontSize: '1.75rem', fontWeight: 600 },
    body1: { fontSize: '1rem', fontWeight: 400 },
    button: { fontSize: '1rem', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Disable uppercase on buttons
          borderRadius: 8,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: colors.primaryDark,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: colors.primaryLight,
          borderRadius: 8,
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.25)',
        },
      },
    },
  },
};

const theme = createTheme(themeOptions);

export default theme;
